import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Grid, InputLabel } from '@material-ui/core';
import {
    FHEWeatherAutoComplete,
    FHEReactSelect,
    FHEContainerForm,
    FHEContainerScroll,
    FHETitle,
    FHETextField,
    FormEditButton,
    FormSaveButton,
    FormPlusButton,
    FormMinusButton,
    FormCheckButton,
} from 'data/components';
import { Toastr } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import { SvgDistrict, SvgApartments, SvgManagement } from 'data/common/iconsvg';
import memoizeOne from 'memoize-one';
import FileManager from '../../../components/FileManager';

class FormManagement extends Component {
    static propTypes = {
        sendDataFunc: PropTypes.func.isRequired,
        management: PropTypes.object,
        history: PropTypes.object.isRequired,
        renderOtherChildren: PropTypes.func,
        type: PropTypes.string.isRequired,
        managementId: PropTypes.string.isRequired,
        searchCityUrl: PropTypes.string.isRequired,
        profile: PropTypes.object.isRequired,
    };

    static defaultProps = {
        renderOtherChildren: null,
        management: null,
    };

    constructor(props) {
        super(props);
        const { type } = props;

        this.state = {
            formDisabled: type === 'update',
            managementForm: this.getDataForm(),
            textInput_error: {},
            sendLoading: false,
            addedFields: false,
            keyValue: {
                newKey: '',
                newValue: '',
            },
        };
        this.buildingTypes = [
            { value: 'apartments', label: Translator.translate(`generic.management.table.apartments`) },
            { value: 'district', label: Translator.translate(`generic.management.table.district`) },
        ];
    }

    getDataForm = () => {
        const { type, management } = this.props;
        return {
            libelle: type === 'update' ? management.get('libelle') : null,
            buildingType: type === 'update' ? management.get('buildingType') : null,
            weatherCity: type === 'update' ? management.get('weatherCity') : null,
            address: type === 'update' ? management.get('address') : null,
            city: type === 'update' ? management.get('city') : null,
            postalCode: type === 'update' ? management.get('postalCode') : null,
            details:
                type === 'update' && management.get('details')
                    ? management.get('details').toJS()
                    : {
                          nbHomes: '',
                          ecsType: '',
                          heatType: '',
                          functions: '',
                          projectManager: '',
                          projectBuilder: '',
                          programManager: '',
                          technicalPromoter: '',
                          syndicateReferent: '',
                          electricEnterprise: '',
                          heatEnterprise: '',
                          carpentryEnterprise: '',
                      },
        };
    };

    loadInputs = () => {
        this.setState({
            formDisabled: true,
            sendLoading: false,
            managementForm: this.getDataForm(),
        });
    };

    isEmpty = value => {
        return value === null || /^\s*$/.test(value);
    };

    formatForm = () => {
        const { managementForm } = this.state;

        let form = managementForm;
        Object.keys(form).forEach(key => {
            if (form[key] === '') {
                form[key] = null;
            }
        });
        this.setState({
            managementForm: form,
        });
    };

    handleFormError = (fields, message) => {
        let res = {};
        Object.keys(fields).map(field => {
            fields[field].forEach(error => {
                if (res[field] === undefined) res[field] = [];

                res[field].push(
                    <p key={error} className="mb-1">
                        {Translator.translate(`general.fields.error.${error}`)}
                    </p>,
                );
            });
        });

        this.setState({
            textInput_error: res,
        });

        return Toastr.error(message);
    };

    confirmEdit = () => {
        const { managementForm } = this.state;
        const { sendDataFunc } = this.props;

        this.formatForm();

        if (this.validateForm(managementForm)) {
            this.setState({
                sendLoading: true,
            });

            return sendDataFunc(managementForm)
                .then(() => {
                    Toastr.success(Translator.translate(`generic.management.actions.editManagementSuccess`, managementForm.libelle));
                    this.loadInputs();
                    this.setState({
                        formDisabled: true,
                        sendLoading: false,
                    });
                })
                .catch(error => {
                    this.setState({
                        sendLoading: false,
                    });
                    Toastr.error(
                        Translator.translateWithFallback(
                            `api.message.${error.message}`,
                            `generic.management.actions.editManagementError`,
                            managementForm.libelle,
                        ),
                    );
                    if (error.validation && error.validation.errors) {
                        return this.handleFormError(
                            error.validation.errors,
                            Translator.translate(`generic.management.actions.editManagementError`, managementForm.libelle),
                        );
                    }
                });
        }
    };

    handleEdit = () => {
        const { formDisabled } = this.state;

        if (!formDisabled) this.loadInputs();
        this.setState({
            formDisabled: !formDisabled ? true : !formDisabled,
            textInput_error: {},
        });
    };

    removeKey = (myObj, deleteKey) => {
        return Object.assign(
            {},
            ...Object.entries(myObj)
                .filter(([k]) => k !== deleteKey)
                .map(([k, v]) => ({ [k]: v })),
        );
    };

    handleFormData = (field, value) => {
        const { managementForm } = this.state;
        this.setState({
            managementForm: { ...managementForm, [field]: value },
        });
    };

    handleRemoveField = field => {
        const details = this.state.managementForm.details;
        delete details[field];
        this.setState({
            details,
        });
    };

    handleChange = event => {
        const { managementForm, textInput_error } = this.state;
        let targetValue = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        const fieldLengthRules = {
            libelle: 500,
            address: 500,
            city: 255,
            postalCode: 5,
        };

        let newTextInput_error = this.removeKey(textInput_error, event.target.name);

        let maxLength = fieldLengthRules[event.target.name];
        if (maxLength && targetValue.length > maxLength) targetValue = managementForm[event.target.name];
        if (targetValue === '') targetValue = null;

        this.setState({
            managementForm: { ...managementForm, [event.target.name]: targetValue },
            textInput_error: newTextInput_error,
        });
    };

    handleDetailChange = event => {
        const details = this.state.managementForm.details;
        let targetName = event.target.name;
        let targetValue = event.target.value;

        details[targetName] = targetValue;

        this.setState({
            details,
        });
    };

    handleDetailKeyChange = event => {
        const keyValue = this.state.keyValue;
        let targetValue = event.target.value;
        keyValue['newKey'] = targetValue;

        this.setState({
            keyValue,
        });
    };

    handleDetailValueChange = event => {
        const keyValue = this.state.keyValue;
        let targetValue = event.target.value;
        keyValue['newValue'] = targetValue;

        this.setState({
            keyValue,
        });
    };

    saveDetailChange = () => {
        const keyValue = this.state.keyValue;
        const details = this.state.managementForm.details;
        details[keyValue.newKey] = keyValue.newValue;

        this.setState({
            details,
            addedFields: false,
            keyValue: {
                newKey: '',
                newValue: '',
            },
        });
    };

    saveManagement = () => {
        const { managementForm } = this.state;
        const { sendDataFunc, history, profile } = this.props;

        this.formatForm();

        if (this.validateForm(managementForm)) {
            this.setState({
                formDisabled: true,
                sendLoading: true,
            });
            return sendDataFunc(managementForm)
                .then(managementId => {
                    Toastr.success(Translator.translate(`generic.management.actions.addManagementSuccess`, managementForm.libelle));
                    if (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('managementDetails'))
                        return history.push(`/${history.environment}/management/detail/${managementId}`);
                    return history.push(`/${history.environment}/management`);
                })
                .catch(error => {
                    Toastr.error(Translator.translate(`generic.management.actions.addManagementError`, managementForm.libelle));
                    this.setState({
                        formDisabled: false,
                        sendLoading: false,
                    });
                    if (error.validation && error.validation.errors) {
                        return this.handleFormError(
                            error.validation.errors,
                            Translator.translate(`generic.management.actions.addManagementError`, managementForm.libelle),
                        );
                    }
                });
        }
    };

    validateForm(form) {
        const errors = {};

        if (this.isEmpty(form.libelle)) {
            errors['libelle'] = Translator.translate('general.fields.error.any.empty');
        }
        if (this.isEmpty(form.buildingType)) {
            errors['buildingType'] = Translator.translate('general.fields.error.any.empty');
        }
        if (form.buildingType !== 'district') {
            if (this.isEmpty(form.address)) {
                errors['address'] = Translator.translate('general.fields.error.any.empty');
            }
        }
        if (this.isEmpty(form.city)) {
            errors['city'] = Translator.translate('general.fields.error.any.empty');
        }
        if (this.isEmpty(form.postalCode)) {
            errors['postalCode'] = Translator.translate('general.fields.error.any.empty');
        }

        this.setState({
            textInput_error: errors,
        });

        return Object.keys(errors).length <= 0;
    }

    renderButtonsForm() {
        const { formDisabled, sendLoading } = this.state;
        const { profile, type, history } = this.props;
        const userRights = profile.getIn(['user_rights', history.environment], []);
        if (type === 'update') {
            if (profile.get('admin') || userRights.includes('managementDetailsUpdate'))
                return (
                    <FormEditButton
                        formDisabled={formDisabled}
                        handleEdit={this.handleEdit}
                        confirmEdit={this.confirmEdit}
                        sendLoading={sendLoading}
                    />
                );
        } else if (profile.get('admin') || userRights.includes('managementAdd'))
            return <FormSaveButton sendFunc={this.saveManagement} sendLoading={sendLoading} />;
    }

    getSelectedBuildingType = memoizeOne(type => {
        return this.buildingTypes.find(x => x.value === type);
    });

    handleReactSelect = (event, options) => {
        const { managementForm } = this.state;

        this.setState({
            managementForm: { ...managementForm, [options.name]: event.value },
        });
    };

    renderAddDetailButtons = () => {
        const { formDisabled, addedFields } = this.state;
        if (formDisabled) {
            return null;
        } else if (!addedFields) {
            return <FormPlusButton addDetail={() => this.setState({ addedFields: true })} />;
        } else {
            return (
                <FormCheckButton
                    addKeyValue={() => {
                        this.saveDetailChange();
                    }}
                />
            );
        }
    };

    render() {
        const { textInput_error, formDisabled, managementForm, addedFields, keyValue } = this.state;
        const { type, management, renderOtherChildren, history, searchCityUrl, managementId, profile } = this.props;
        const fileManagerRights = profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('managementFilesActions');

        return (
            <Fragment>
                <FHETitle
                    title={type === 'update' ? management.get('libelle') : Translator.translate('general.addManagement')}
                    Icon={
                        management.buildingType === null ? SvgManagement : managementForm.buildingType === 'apartments' ? SvgApartments : SvgDistrict
                    }
                />
                {this.renderButtonsForm()}

                <FHEContainerScroll>
                    <FHEContainerForm>
                        <Grid container spacing={3} alignItems={'center'}>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHETextField
                                    disabled={formDisabled}
                                    id="libelle"
                                    value={!managementForm.libelle || managementForm.libelle === null ? '' : managementForm.libelle}
                                    error={textInput_error.libelle}
                                    label={Translator.translate('general.table.column.libelle')}
                                    name="libelle"
                                    onChange={this.handleChange}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEReactSelect
                                    name="buildingType"
                                    label={Translator.translate('general.table.column.buildingType')}
                                    disabled={formDisabled}
                                    onChange={this.handleReactSelect}
                                    value={this.getSelectedBuildingType(managementForm.buildingType)}
                                    choices={this.buildingTypes}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHETextField
                                    disabled={formDisabled}
                                    id="address"
                                    value={!managementForm.address || managementForm.address === null ? '' : managementForm.address}
                                    error={textInput_error.address}
                                    label={Translator.translate('general.table.column.address')}
                                    name="address"
                                    onChange={this.handleChange}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHETextField
                                    disabled={formDisabled}
                                    id="city"
                                    value={!managementForm.city || managementForm.city === null ? '' : managementForm.city}
                                    error={textInput_error.city}
                                    label={Translator.translate('general.table.column.city')}
                                    name="city"
                                    onChange={this.handleChange}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHETextField
                                    disabled={formDisabled}
                                    id="postalCode"
                                    value={!managementForm.postalCode || managementForm.postalCode === null ? '' : managementForm.postalCode}
                                    error={textInput_error.postalCode}
                                    label={Translator.translate('general.table.column.postalCode')}
                                    name="postalCode"
                                    onChange={this.handleChange}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEWeatherAutoComplete
                                    disabled={formDisabled}
                                    id="weatherCity"
                                    baseValue={managementForm.weatherCity === null ? '' : managementForm.weatherCity}
                                    error={textInput_error.weatherCity}
                                    label={Translator.translate('general.table.column.weatherCity')}
                                    name="weatherCity"
                                    query={searchCityUrl}
                                    selectMeteo={this.handleFormData}
                                />
                            </Grid>
                            {this.state.managementForm.details &&
                                Object.entries(this.state.managementForm.details).map(([key, value]) => (
                                    <Grid key={key} container item sm={12} md={6} lg={4} className={{ display: 'flex', justifyContent: 'center' }}>
                                        {!formDisabled && <FormMinusButton removeDetail={() => this.handleRemoveField(key)} />}

                                        <FHETextField
                                            disabled={formDisabled}
                                            id={key}
                                            value={value}
                                            label={Translator.translateWithFallback(`general.table.column.details.${key}`, key)}
                                            name={key}
                                            onChange={this.handleDetailChange}
                                            fullWidth={false}
                                        />
                                    </Grid>
                                ))}
                            {addedFields && (
                                <Grid
                                    key={'addField'}
                                    container
                                    item
                                    sm={12}
                                    md={6}
                                    lg={4}
                                    className={{ display: 'flex', justifyContent: 'center', gap: 2 }}
                                >
                                    <FHETextField
                                        disabled={formDisabled}
                                        id={'addedField'}
                                        value={keyValue.newKey}
                                        label={'Clé'}
                                        name={'addedField'}
                                        fullWidth={false}
                                        onChange={this.handleDetailKeyChange}
                                    />
                                    <FHETextField
                                        disabled={formDisabled}
                                        id={'addedValue'}
                                        value={keyValue.newValue}
                                        label={'Valeur'}
                                        name={'addedValue'}
                                        onChange={this.handleDetailValueChange}
                                        fullWidth={false}
                                    />
                                </Grid>
                            )}
                            <Grid container item sm={12} md={6} lg={4}>
                                {this.renderAddDetailButtons()}
                            </Grid>
                        </Grid>
                    </FHEContainerForm>
                    {type === 'update' && (
                        <FileManager hasRights={fileManagerRights} type="managements" id={managementId} formDisabled={formDisabled} />
                    )}
                    {renderOtherChildren && renderOtherChildren()}
                </FHEContainerScroll>
            </Fragment>
        );
    }
}

function mapStateToProps(state, props) {
    const { history, match } = props;
    let management = state.environments[history.environment].data.Managements.getIn(['list', match.params.managementId], new Map());

    return {
        profile: state.data.user,
        management,
        managementId: match.params.managementId,
        searchCityUrl: state.data.searchCityUrl,
    };
}

export default withRouter(renderEnvComponent('scenes/Management/Form/FormManagement', connect(mapStateToProps)(FormManagement)));



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Management/Form/FormManagement.js